import UIExplanationTextInput from 'components/ui/UITextInput/components/UIExplanationTextInput';
import React from 'react';
import DisputeProgressWidget from '../widgets/DisputeProgressWidget';
import "./styles.css";
import FormContainer, { FormButtonContainer, FormRow } from 'components/shared/containers/FormContainer';
import UIRadio from 'components/ui/UIRadio';
import { UICancelButton, UIPrimaryButton } from 'components/ui/UIButton';
import UIDatePicker from 'components/ui/UIDatePicker ';
import Classes, { Transaction } from 'model';
import { BCMSDate, BCMSDefaultModel, BCMSStateManagerCRUD, BCMSRecord, ModalOpen, StateManager, useBCMSContext, useParams, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";

/**
 * @function DisputeServiceReasonView
 * @return {React.Component}
 * @exported true
 * @description The view that shows when user is disputing a service for a reason
 */

export default function DisputeServiceReasonView(props) {
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  const navigate = useRoute();
  const { goStep, nextStep, prevStep, state } = useWorkflow() ?? {};
  const cardID = useParams().cardID ?? "0";
  const paramsTransactionID = useParams().transactionID ?? "0";
  const data = { ...getDefaultData(paramsTransactionID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    update: type => (val, label) => {
      let reason = label.toLowerCase();
      const crud = BCMSStateManagerCRUD.init(state);

      if(type === "isThisAServiceRecurringCharge") {
        if(reason === "yes") {
          //crud
          //.update([ "data", "dispute", "whyDidntYouReturnTheMerchandise" ], "");
        } else {
          crud
          .update([ "data", "dispute", "didYouAttemptToCancelTheService" ], "")
          .update([ "data", "dispute", "whenDidYouCancelTheService" ], "")
          //
        }
      }
      
      crud
        .update([ "data", "dispute", type ], reason)
        .update([ "ui" ], ui)
        .submit(setState);
    },
    
    // User might select a date from a calendar or type a date.
    updateCustomCalendar: type => val => {
      const crud = BCMSStateManagerCRUD.init(state);

      if(val instanceof BCMSDate) {
        crud.update([ "data", "dispute", type ], val)
      } else {
        let validatedTypeDate = new Date(val);
        let typedDateIsValid = validatedTypeDate.toString() !== "Invalid Date";

        if(typedDateIsValid) {
          validatedTypeDate = BCMSDate.init(validatedTypeDate);
        } else {
          validatedTypeDate = BCMSDate.init(0);
        }

        crud.update([ "data", "dispute", type ], validatedTypeDate)
      }

      crud.update([ "data", "dispute", "didSelectWhenWasTheMerchandiseReturned"], true)
      crud.submit(setState);
    },

    updateTextInput: type => val => {
      BCMSStateManagerCRUD.init(state)
        .update([ "data", "dispute", type ], val)
        .update([ "ui" ], ui)
        .submit(setState);
    },

    next: evt => {
      data.workflowType = "services";
      goStep(4, { data, ui });
    },

    cancel: () => {
      navigate(`/home/transactiondetails/${ cardID }/${ paramsTransactionID }`);
      //goStep(0)
    }
  });

  return(
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = transactionID => {
  const transaction = Transaction.initByID(transactionID);
  const dispute = BCMSDefaultModel.transactionDispute();
  dispute.transaction = transaction;

  return {
    dispute
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, next, cancel, update, updateCustomCalendar, updateTextInput } = useStateManager();
  const dispute = data.dispute ?? {};

  const nextButtonEnabledCondition1 = dispute.whyAreYouDissatisfiedWithTheService.length > 0
  && dispute.isThisAServiceRecurringCharge === "no";

  const nextButtonEnabledCondition2 = dispute.whyAreYouDissatisfiedWithTheService.length > 0
  && dispute.isThisAServiceRecurringCharge === "yes"
  && dispute.didYouAttemptToCancelTheService === "no";

  const nextButtonEnabledCondition3 = dispute.whyAreYouDissatisfiedWithTheService.length > 0
  && dispute.isThisAServiceRecurringCharge === "yes"
  && dispute.didYouAttemptToCancelTheService === "yes"
  && dispute.whenDidYouCancelTheService instanceof BCMSDate;

  const nextButtonIsEnabled = nextButtonEnabledCondition1 || nextButtonEnabledCondition2 || nextButtonEnabledCondition3;
  const onCancel = evt => cancel();

  return (
    <div className="dispute-service-reason-view">
      <DisputeProgressWidget step="1" />
      <FormContainer>
        <FormRow>
          <p className="form-label">Why are you dissatisfied with the service? *</p>
          <UIExplanationTextInput maxLength="300" value={ dispute.whyAreYouDissatisfiedWithTheService } 
        onChange={ updateTextInput("whyAreYouDissatisfiedWithTheService") } />
        </FormRow>
        <FormRow>
          <p className="form-label">Is this a recurring charge? *</p>
          <UIRadio label="Yes" value={ dispute.isThisAServiceRecurringCharge === "yes" } 
          onChange={ update("isThisAServiceRecurringCharge") } />
          <UIRadio label="No" value={ dispute.isThisAServiceRecurringCharge === "no" }
          onChange={ update("isThisAServiceRecurringCharge") } />
        </FormRow>

        {/* This is where the widgets that appear after selections of previous questions are asked. */}
        {/* These DO NOT need to be wrapped by the FormRow component as the widgets have the FormRow component already built in  */}
        { dispute.isThisAServiceRecurringCharge === "yes" &&
        <CancelServiceWidget />
        }
        { dispute.didYouAttemptToCancelTheService === "yes" &&
        <CancelServiceDateWidget />
        }

        <FormButtonContainer>
          <UIPrimaryButton text="Next" className={ nextButtonIsEnabled ? "" : "disabled" } onClick={ next }/>
          <ModalOpen id="CancelDisputeTransactionModal" data={ { onCancel: onCancel } }>
            <UICancelButton text="Cancel" />
          </ModalOpen>
        </FormButtonContainer>
      </FormContainer>
      
    </div>
  )
}

/**
 * @function CancelServiceWidget
 * @return {React.Component}
 * @exported false
 * @description The widget that asks if the service was cancelled. 
 */

function CancelServiceWidget(props) {
  const { data, update } = useStateManager();
  const dispute = data.dispute ?? {};

  return (
    <div className="cancel-service-widget">
      <FormRow>
        <p className="form-label">Did you attempt to cancel the service? *</p>
        <UIRadio label="Yes" value={ dispute.didYouAttemptToCancelTheService === "yes" }
          onChange={ update("didYouAttemptToCancelTheService") } />
        <UIRadio label="No" value={ dispute.didYouAttemptToCancelTheService === "no" }
          onChange={ update("didYouAttemptToCancelTheService") } />
      </FormRow>
    </div>
  );
}

/**
 * @function CancelServiceDateWidget
 * @return {React.Component}
 * @exported false
 * @description The widget that asks what date the service was canceled
 */

function CancelServiceDateWidget(props) {
  const { data, updateCustomCalendar } = useStateManager();
  const dispute = data.dispute ?? {};

  return(
    <div className="cancel-service-date-widget">
      <FormRow>
        <p className="form-label">When did you cancel the service? *</p>
        <UIDatePicker dateLabel="Date (MMM DD, YYYY)" value={ dispute.whenDidYouCancelTheService } allowPast={ true } allowFuture={ false } onChange={ updateCustomCalendar("whenDidYouCancelTheService") }>
        <p className="sub-text cancel-service-helper-text">Enter a guess if necessary</p>
        </UIDatePicker>
      </FormRow>
    </div>
  );
}